export default "__VITE_ASSET__Doz$3Hzc__"